// src/js/gsap-setup.js
import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";
import Lenis from "lenis";

gsap.registerPlugin(ScrollTrigger);

// Register ScrollTrigger globally for debugging
if (typeof window !== "undefined") {
    window.ScrollTrigger = ScrollTrigger;
    window.gsap = gsap;
}

export const lenis = new Lenis();

lenis.on("scroll", ScrollTrigger.update);

gsap.ticker.add((time) => {
    lenis.raf(time * 1000);
});

gsap.ticker.lagSmoothing(0);

export { gsap, ScrollTrigger };
